import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';
import { formatRelativeTime } from '../../utils/workspaceFormat';

export default function InboxPage() {
  const { data } = useDashboardData();
  const { locale, t } = useLocale();
  const items = data?.inbox?.notifications || [];

  return (
    <MainPanel title={t('inbox.title')}>
      {items.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('inbox.emptyTitle')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('inbox.emptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {items.map((n) => (
            <div
              key={n.id}
              style={{
                background: '#1f2229',
                borderRadius: 12,
                padding: '16px 20px',
                color: '#f3f4f6',
                border: '1px solid rgba(255,255,255,0.06)',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>{n.title}</h3>
                <span style={{ fontSize: 12, color: '#6b7280', flexShrink: 0 }}>
                  {formatRelativeTime(n.createdAt, locale)}
                </span>
              </div>
              <p style={{ margin: '10px 0 0', fontSize: 14, color: '#9ca3af' }}>{n.body}</p>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
